import { z } from 'zod'

/**
 * Where a company role works (docs/custom-roles.spec.md, "Roles"): every venue
 * the company has, now and later, or the venues each person on it is assigned.
 * Mirrors the `TenantRoleReach` enum in the Prisma schema (`check:enums`).
 */
export const TENANT_ROLE_REACHES = ['company', 'venues'] as const

export const tenantRoleReachSchema = z.enum(TENANT_ROLE_REACHES)

export type TenantRoleReach = z.infer<typeof tenantRoleReachSchema>
